module.exports = __webpack_public_path__ + "static/DonaAlt-Regular-33e12ba32cc8a48c853cb911f398822a.woff2";